import React from "react";
import MessageTemplateTable from "../components/MessageTemplateTable";
import LayoutAdmin from "../components/LayoutAdmin";

const MessageTemplatesPage: React.FC = () => {
    return (
        <LayoutAdmin>
            <MessageTemplateTable />
        </LayoutAdmin>
    );
};

export default MessageTemplatesPage;

